import React from 'react';
import { Col } from 'reactstrap';
import classNames from 'classnames';
import { MusicMarketingBoxProps } from './props';

const MusicMarketingBoxComponent: React.FC<MusicMarketingBoxProps> = ({ className, text }) => {
  return (
    <Col xs={12} md={12} className={classNames('music-marketing-box', className)}>
      <div className="d-flex">
        <div className="rhomb" />
        <div>
          <span className="font-weight-normal">{text}</span>
        </div>
      </div>
    </Col>
  );
};

export const MusicMarketingBox = React.memo(MusicMarketingBoxComponent);
